<template>
	<!-- footer -->
	<footer id="footer">
		<div class="finner">
			<div class="ftop">
				<div class="flogo"></div>
				<ul class="flink">
					<li @click="showPrivacyModal">개인정보처리방침</li>
					<li @click="showTermsModal">이용약관</li>
				</ul>
			</div>
			<div class="finfo">
				<div class="ftxt1">
					<p><strong><span>고객센터</span> 070-7788-1458</strong></p>
					<p><strong><span>이메일</span> info@wetree.kr</strong></p>
					<p>평일 : 10:00 ~ 17:00&ensp;점심 : 12:00 ~ 13:00&ensp;토요일, 일요일, 공휴일 휴무</p>
				</div>
				<div class="ftxt2">
					<p>대표자 : 이동훈</p>
					<p>사업자번호 : 667-88-02056</p>
					<p>통신판매업 신고번호 : 2021-부산부산진-1366</p>
					<p>주소 : 부산광역시 금정구 금강로321번길 57 3층</p>
				</div>
				<div class="ftxt3">&copy; 2024. 덴탈클라우드 all rights reserved.</div>
			</div>
		</div>
	</footer>

	<!-- 231107 html [약관 모달] 추가 -->
	<section id="modal_agree">
		<div class="fModal_box fModal_box1" v-show="isPrivacyModalVisible">
			<div class="modal_tit"><span class="icon_modal"></span>개인정보처리방침</div>
			<div class="modal_close" @click="closeModals"><img src="/img/common/icon_modal_close.png" alt="닫기"></div>
			<div class="modal_inner">
				<div class="agree_txt">
					<include-privacy />
				</div>
			</div>
		</div>
		<div class="fModal_box fModal_box2" v-show="isTermsModalVisible">
			<div class="modal_tit"><span class="icon_modal"></span>이용약관</div>
			<div class="modal_close" @click="closeModals"><img src="/img/common/icon_modal_close.png" alt="닫기"></div>
			<div class="modal_inner">
				<div class="agree2_txt agree_txt">
					<include-terms />
				</div>
			</div>
		</div>
	</section>
	<!-- 231107 html [약관 모달] 추가 끝 -->

	<!-- fix btn -->
	<div id="top_btn" @click="scrollToTop"><img src="/img/common/top_btn.png" alt="맨위로"></div>
	<div class="modal_bg"></div>
</template>

<script>
import { ref } from 'vue';
import privacy from '../include/privacy.vue';
import terms from '../include/terms.vue';

export default {
	components: {
		'include-privacy': privacy,
		'include-terms': terms,
	},
}
</script>

<script setup>
const isPrivacyModalVisible = ref(false);
const isTermsModalVisible = ref(false);

const showPrivacyModal = () => {
	isPrivacyModalVisible.value = true;
	scrollToTopOfModal();
};

const showTermsModal = () => {
	isTermsModalVisible.value = true;
	scrollToTopOfModal();
};

const closeModals = () => {
	isPrivacyModalVisible.value = false;
	isTermsModalVisible.value = false;
};

const scrollToTopOfModal = () => {
	const modalInner = document.querySelector('.modal_inner');
	if (modalInner) {
		modalInner.scrollTop = 0;
	}
};

const scrollToTop = () => {
	window.scrollTo({ top: 0, behavior: 'smooth' });
};
</script>
